export type { AddedAnalyticsProps } from './with-create-fire-ui-analytics';
export { default as withCreateFireUIAnalytics } from './with-create-fire-ui-analytics';
